import { render, staticRenderFns } from "./FilterByTagDropdown.vue?vue&type=template&id=245c3638&scoped=true"
import script from "./FilterByTagDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterByTagDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterByTagDropdown.vue?vue&type=style&index=0&id=245c3638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c3638",
  null
  
)

export default component.exports